import React from "react"

export default function Footer() {
  return (
    <footer className="main-footer">
      {/* To the right */}
      <div className="float-right d-none d-sm-inline">Adtractive Group WebApp v{process.env.REACT_APP_VERSION}</div>
      {/* Default to the left */}
      <strong>
        Copyright © 2025 <a href="https://media.adtractive-group.fr">Adtractive Group</a>.
      </strong>{" "}
      Tous droits réservés.
    </footer>
  )
}
